import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { FeedbackEmailSettings } from '@mp/shared/helper-links/feedback/domain';

import { MailSenderDetails } from '../../models';

import { FeedbackMailToHrefPipe } from './feedback-mail-to-href.pipe';

@Component({
  selector: 'mp-feedback-mail-to-button',
  templateUrl: './feedback-mail-to-button.component.html',
  styleUrl: './feedback-mail-to-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatAnchor, MatTooltip, FeedbackMailToHrefPipe],
})
export class FeedbackMailToButtonComponent {
  readonly mailSenderDetails: InputSignal<MailSenderDetails> = input.required<MailSenderDetails>();

  readonly feedbackEmailSettings: InputSignal<FeedbackEmailSettings> = input.required<FeedbackEmailSettings>();

  readonly isSmall: InputSignal<boolean> = input.required<boolean>();
}
